import { render, staticRenderFns } from "./AccountDetailsForm.vue?vue&type=template&id=655cd388&"
import script from "./AccountDetailsForm.vue?vue&type=script&lang=js&"
export * from "./AccountDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports